import { createApp, type Component } from 'vue'
import 'virtual:windi.css'
import '@ropescore/components/style.css'
import App from './App.vue'
import router from './router'
import { DefaultApolloClient } from '@vue/apollo-composable'
import { apolloClient } from './apollo'
import { initFaro, setFaroView } from './faro'

const faro = initFaro()

const app = createApp(App as Component)

if (faro != null) {
  app.config.errorHandler = (err, instance, info) => {
    const route = router.currentRoute.value

    faro.api.pushError(err instanceof Error ? err : new Error(String(err)), {
      context: {
        vueInfo: info,
        vueComponentName: instance?.$options.name ?? instance?.$options.__name ?? 'unknown',
        routePath: route.path,
        routeFullPath: route.fullPath,
      },
    })

    console.error(err)
  }

  router.afterEach(setFaroView)
}

app.provide(DefaultApolloClient, apolloClient)
  .use(router)
  .mount('#app')
